<template>
    <div class="clients">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="wrapper">
                        <div class="client d-none d-xl-block">
                            <img src="/static/images/clients/gunnerdue.png">
                        </div>

                        <div class="client hidden-xs-down">
                            <img src="/static/images/clients/oris.png">
                        </div>

                        <div class="client d-none d-xl-block">
                            <img src="/static/images/clients/jupiter-cykler.png">
                        </div>

                        <div class="client d-none d-sm-block">
                            <img src="/static/images/clients/samsoesamsoe.png">
                        </div>

                        <div class="client d-none d-sm-block">
                            <img src="/static/images/clients/real.png">
                        </div>

                        <div class="client">
                            <img src="/static/images/clients/stender.png">
                        </div>

                        <div class="client d-none d-xl-block">
                            <img src="/static/images/clients/leonpetersen.png">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .clients {
        width: 100%;
        background: url('/static/images/curve.png');
        background-size: cover;
        

        .wrapper {
            width: 100%;
            padding: 20px;
            border-radius: 10px;
            box-shadow: 0 10px 20px rgba(0,0,0,0.05), 0 6px 6px rgba(0,0,0,0.05);
            background-color: #fff;

            display: flex;
            text-align: center;

            .client {
                flex: 1;
            }
        }
    }
</style>

<script>
    export default {
        data() {
            return {
                customers: []
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Clients.vue